import * as React from 'react';
import {
  ProgressBar,
  StackLayout,
  StackItem,
  UtilityText,
} from '@leagueplatform/genesis-core';
import { RewardPointsIcon } from '@leagueplatform/rewards-common';
import { useIntl } from '@leagueplatform/locales';

export interface RewardProgramsProgressProps {
  currentValue: number;
  maxValue: number;
  showProgress: boolean;
  iconUrl?: string;
}

export const RewardProgramsProgress = ({
  iconUrl,
  currentValue,
  maxValue,
  showProgress,
}: RewardProgramsProgressProps) => {
  const { formatNumber, formatMessage } = useIntl();

  const accessibilityLabel = [
    formatMessage(
      { id: 'X_OF_Y' },
      { current: formatNumber(currentValue), total: formatNumber(maxValue) },
    ),
    formatMessage({ id: 'REWARD_POINTS_EARNED' }),
  ].join(' ');

  return (
    <StackLayout
      orientation="vertical"
      verticalAlignment="center"
      spacing="$half"
    >
      <StackLayout
        orientation="horizontal"
        spacing="$quarter"
        verticalAlignment="center"
        aria-hidden={showProgress ? true : undefined}
      >
        <RewardPointsIcon iconUrl={iconUrl} value={currentValue} />
        <UtilityText css={{ fontSize: 'inherit' }}>/</UtilityText>
        <UtilityText css={{ fontSize: 'inherit' }}>
          {formatNumber(maxValue)}
        </UtilityText>
        <UtilityText css={{ fontSize: 'inherit' }}>
          {formatMessage({ id: 'REWARD_POINTS_EARNED' })}
        </UtilityText>
      </StackLayout>

      {showProgress && (
        <StackItem css={{ width: '100%' }}>
          <ProgressBar
            data-testid="progress-bar"
            fillProgressValue={currentValue}
            maxProgressValue={maxValue}
            minProgressValue={0}
            fill="brand"
            height="large"
            accessibilityLabel={accessibilityLabel}
            css={{
              '& .GDS-progress-bar-background': {
                backgroundColor: '$interactiveBackgroundDisabled',
                borderColor: 'transparent',
              },
              '& .GDS-progress-bar-track': {
                backgroundColor: '$successBorderDefault',
              },
            }}
          />
        </StackItem>
      )}
    </StackLayout>
  );
};
